import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Search, Calendar, MessageCircle, User } from 'lucide-react';
export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const navItems = [{
    path: '/home',
    icon: Home,
    label: 'Home'
  }, {
    path: '/explore',
    icon: Search,
    label: 'Explore'
  }, {
    path: '/appointments',
    icon: Calendar,
    label: 'Visits'
  }, {
    path: '/chat',
    icon: MessageCircle,
    label: 'Chat'
  }, {
    path: '/profile',
    icon: User,
    label: 'Profile'
  }];
  // Don't show on certain screens
  const hiddenPaths = ['/', '/onboarding', '/signup', '/otp', '/usertype', '/location-setup', '/needs-today', '/video-call', '/emergency'];
  if (hiddenPaths.includes(location.pathname) || location.pathname.includes('/booking/')) {
    return null;
  }
  return <div className="fixed bottom-0 left-0 right-0 w-full max-w-[430px] mx-auto bg-white border-t border-ui-border pb-safe z-50 shadow-nav" data-id="element-89">
      <div className="flex justify-around items-center h-16 px-2" data-id="element-90">
        {navItems.map(item => {
        const isActive = location.pathname.startsWith(item.path);
        const Icon = item.icon;
        return <button key={item.path} onClick={() => navigate(item.path)} className="flex flex-col items-center justify-center w-16 h-full space-y-1" data-id="element-91">
              <Icon size={24} className={isActive ? 'text-brand-primary' : 'text-text-secondary'} strokeWidth={isActive ? 2.5 : 2} data-id="element-92" />
              <span className={`text-[10px] font-medium ${isActive ? 'text-brand-primary' : 'text-text-secondary'}`} data-id="element-93">
                {item.label}
              </span>
            </button>;
      })}
      </div>
    </div>;
}